import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitch() {
  const { i18n } = useTranslation();
  const current = i18n.language;
  const toggle = () => {
    const next = current === 'it' ? 'en' : 'it';
    i18n.changeLanguage(next);
    localStorage.setItem('lang', next);
  };
  return (
    <button
      onClick={toggle}
      className="text-xs font-medium text-gray-500 dark:text-zinc-500 hover:text-gray-700 dark:hover:text-zinc-300 transition-colors border border-gray-300 dark:border-zinc-700 hover:border-gray-500 dark:hover:border-zinc-500 rounded-md px-2 py-1 tracking-wider bg-white dark:bg-gray-800"
      aria-label="Switch language"
    >
      {current === 'it' ? 'EN' : 'IT'}
    </button>
  );
}
